<script setup>
import { computed, ref } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

// `<details>` không dùng được: markdown-it chạy `html: false` nên tag bị escape.
// ponytail: đo bằng độ dài chuỗi thay vì scrollHeight — khỏi ResizeObserver và
// khỏi nhấp nháy một nhịp khi render lại. Xem SETUP.md 2.9.
const COLLAPSE_THRESHOLD = 600;
const CLAMP_LINES = 8;

const { variant } = useMessageContext();

const isExpanded = ref(false);

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});

// Activity message vốn một dòng, không cần nút.
const isCollapsible = computed(
  () =>
    variant.value !== MESSAGE_VARIANTS.ACTIVITY &&
    props.content.length > COLLAPSE_THRESHOLD
);
</script>

<template>
  <div class="flex flex-col items-start gap-1">
    <span
      v-dompurify-html="formattedContent"
      class="prose prose-bubble"
      :class="{ 'overflow-hidden': isCollapsible && !isExpanded }"
      :style="
        isCollapsible && !isExpanded
          ? {
              display: '-webkit-box',
              '-webkit-line-clamp': CLAMP_LINES,
              '-webkit-box-orient': 'vertical',
            }
          : null
      "
    />
    <button
      v-if="isCollapsible"
      type="button"
      class="text-sm font-medium underline cursor-pointer opacity-80 hover:opacity-100"
      @click="isExpanded = !isExpanded"
    >
      {{
        isExpanded ? $t('CONVERSATION.SHOW_LESS') : $t('CONVERSATION.SHOW_MORE')
      }}
    </button>
  </div>
</template>
